import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertTiffToPng() {
  return (
    <ImageConverterTemplate
      sourceFormat="TIFF"
      targetFormat="PNG"
      acceptTypes=".tiff,.tif,image/tiff"
      slug="convert-tiff-to-png"
      gradientColors="from-purple-500 to-indigo-600"
      accentColor="purple"
    />
  );
}
